import React from "react";
import varaahaEmblem from "../../Assests/varaaha_emblem.jpeg";
import "./PageLoader.css";

function PageLoader() {
  return (
    <div className="page-loader-container" role="status" aria-live="polite" aria-label="Loading page content">
      <div className="loader-content-box">
        <div className="loader-logo-icon">
          <img src={varaahaEmblem} alt="Varaaha Golden Boar Emblem" className="loader-logo-img" />
        </div>
        <div className="loader-text">
          <span className="loader-brand">VARAAHA MINERALS AND MINING</span>
          <span className="loader-sub">Synchronizing Telemetry & Resources...</span>
        </div>
        <div className="loader-bar-wrapper">
          <div className="loader-bar-fill"></div>
        </div>
      </div>
    </div>
  );
}

export default PageLoader;
